import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ContactsModule } from './contacts/contacts.module';
import { MessagesModule } from './messages/messages.module';
import { SharedModule } from './shared/shared.module';

import { STORE_IMPORTS, STORE_PROVIDERS } from './store/store.imports';

import { BearerInterceptor } from './interceptors/bearer.interceptor';

import { AuthGuard } from './shared/guards/auth.guard';
import { NonAuthGuard } from './shared/guards/nonauth.guard';
import { ApiResponseInterceptor } from './interceptors/api-response.interceptor';
import { AccountsModule } from './accounts/accounts.module';
import { MeetingsModule } from './meetings/meetings.module';
import { ContentsModule } from './contents/contents.module';
import { CampaignsModule } from './campaigns/campaigns.module';
import { SubscriptionsModule } from './subscriptions/subscriptions.module';

import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';

import { DatePipe } from '@angular/common';
import { OWL_DATE_TIME_FORMATS } from '@busacca/ng-pick-datetime';
import { ManagerGuard } from './shared/guards/manager.guard';
import { AdminGuard } from './shared/guards/admin.guard';
import { ApiKeysFeatureGuard } from './shared/guards/api-keys-feature.guard';
import { RoleGuard } from './shared/guards/role.guard';
import { FranchiseAccessGuard } from './shared/guards/franchise-access.guard';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NonImpersonatingGuard } from './shared/guards/NonImpersonatingGuard';
import { MasterGuard } from './shared/guards/master.guard';

export const MY_FORMATS = {
  parse: {
    dateInput: 'Y-MM-DD',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'M/Y',
    dateA11yLabel: 'D/M/Y',
    monthYearA11yLabel: 'M/Y',
  },
};

export const MY_MOMENT_FORMATS = {
  parseInput: 'DD/MM/YYYY HH:mm',
  fullPickerInput: 'MM/DD/YYYY HH:mm',
  datePickerInput: 'MM/DD/YYYY',
  timePickerInput: 'hh:mm A',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

// export const MY_FORMATS = {
//   parse: {
//     dateInput: 'Y-MM-DD H:mm:SS',
//   },
//   display: {
//     dateInput: 'D/M/Y h:mma',
//     monthYearLabel: 'M/Y',
//     dateA11yLabel: 'D/M/Y h:mma',
//     monthYearA11yLabel: 'M/Y',
//   },
// };
// tslint:disable-next-line:no-duplicate-imports
@NgModule({
  declarations: [AppComponent],
  imports: [
    ...STORE_IMPORTS,
    SharedModule,
    AccountsModule,
    ContactsModule,
    MessagesModule,
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatNativeDateModule,
    MeetingsModule,
    ContentsModule,
    CampaignsModule,
    SubscriptionsModule,
    NgxIntlTelInputModule,
  ],
  providers: [
    AuthGuard,
    NonAuthGuard,
    ManagerGuard,
    AdminGuard,
    ApiKeysFeatureGuard,
    RoleGuard,
    FranchiseAccessGuard,
    MasterGuard,
    NonImpersonatingGuard,
    DatePipe,
    ...STORE_PROVIDERS,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BearerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiResponseInterceptor,
      multi: true,
    },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },

  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
